export default {
  vdoSetTopic: {
    id: "",
    courseOutlineId: "",
    vdoSetId: "",
    vdoSetUnitId: "",
    no: 0,
    nameLocal: "",
    nameEng: "",
    vdoLength: 0,
    vdoStreamPath: "",
    teacherId: "",
    isEnabled: true,
    remark: "",
  },
  vdoSetTopics: [],
  processing: false,
  error: null,
  success: null,
}



